import { LitElement, html, css } from 'lit'
import '../../../bui/elements/grid'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import '../../../bui/elements/snap-scroller'

customElements.define('k-trips-list', class extends LitElement{

    static properties = {
        qid: { type: String }
    }

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        .trip {
            display: block;
            color: inherit;
            text-decoration: none;
            position: relative;
        }

        .trip .img {
            background-color: var(--blue-muted);
        }

        .trip img,
        .trip .img {
            width: 100%;
            aspect-ratio: 2/3;
            object-fit: cover;
            width: 100%;
            height: auto;
            line-height: 0;
        }

        .trip {
            border: solid 1px rgba(0, 0, 0, .1);
            border-radius: .5em;
            overflow: hidden;
        }

        b-snap-scroller {
            width: 100vw;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-bottom: 2em;
            --gap: 2em;
            --size: min(300px, 50vw);
            --spacer: calc((100vw - var(--content-w))/2);
            --padding: 1em var(--content-pad);

            max-height: 70vh;
        }

        @media (max-width: 599px) {
            b-snap-scroller {
                --gap: 1em;
            }
        }

        h1, h2, h3, h4 {
            font-family: var(--font-header);
            font-weight: bold;
            text-wrap: balance;
            margin: 0;
        }

        .trip > b-grid {
            padding: 1em;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            justify-items: flex-start;
        }
        
        h3 {
            font-size: 1rem;
            line-height: 1.2rem;
            background: rgba(255, 255, 255, .9);
            padding: .25rem;
            display: inline-block;
            text-align: left;
            clip-path: polygon(.1em 0, 100% 0, 99% 100%, 0 100%);
        }

        .img {
            position: relative;
        }

        .block {
            background-color: rgba(255,255,255, .9);
            height: 1em;
            line-height: 1em;
            font-family: var(--font-header);
            font-size: .8em;
            padding: .25em .25em;
            clip-path: polygon(.1em 0, 100% 0, 99% 100%, 0 100%);
        }

        b-snap-scroller::part(button) {
            background: var(--bgd);
            font-size: 3em;
        }

        b-snap-scroller::part(button):hover {
            background-color: var(--blue-muted);
        }

        .view-all {
            background: var(--wp--preset--color--blue-muted);
            display: grid;
            place-items: center;
            text-decoration: none;
            color: inherit;
            border-radius: .5em;
        }
    `

    constructor(){
        super()
        this.qid = 'tripData'
    }

    set qid(val){
        let oldVal = this.qid
        this.__qid = val

        console.log(val);
        
        this.data = window[val] || []
        this.data = this.data.sort((a,b)=>{
            return a.title < b.title ? -1 : 1
        })
    
        this.requestUpdate('qid', oldVal)
    }
    
    get qid(){ return this.__qid}

    render(){return html`
        ${this.renderScroller()}
    `}

    get showViewAll(){ return this.classList.contains('view-all')}

    _render(){return html`
        
        

        <h1>Trekking</h1><br>
        ${this.renderScroller('Trekking')}

        <h1>Peak</h1><br>
        ${this.renderScroller('Peak')}

        <h1>Adventure</h1><br>
        ${this.renderScroller('Adventure')}

    `}

    renderScroller(category){ return html`
        <b-snap-scroller align="center" dir=x scale buttons>

        ${this.data.map(d=>d.categories.find(d=>!category||d.name==category)?html`
            <a class="trip" href=${d.link} .model=${d}>

                <div class="img" >
                    ${unsafeHTML(d.hero.medium)}
                </div>

                <b-grid cols=1 gap=" ">
                    <h3>${d.title}</h3>

                    <b-flex left gap=" ">
                    ${d.days?html`<div class="days block">${d.days} days</div>`:''}
                    ${d.elevation?html`<div class="elevation block">${d.elevation} meters</div>`:''}
                    </b-flex>

                </b-grid>

            </a>
        `:'')}

        ${this.showViewAll?html`
            <a class="view-all" href="/trips">
                <k-h2>View All</k-h2>
            </a>
        `:''}

        </b-snap-scroller>
    `}

})

export default customElements.get('k-trips-list')

